// get routes from children routes for parent routes array
export const getSideDrawerChildrenRoutes = (routesObject) => {
  let childrenRoutes = [];

  for (const value of Object.values(routesObject)) {
    childrenRoutes.push(...value);
  }

  return childrenRoutes;
};
